import scrapRoutes from './routes'

/* @ngInject */
const scrapRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(scrapRoutes.index.path, {
      url: scrapRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'scrapCtrl',
    })
    .state(scrapRoutes.selectWagons.path, {
      url: scrapRoutes.selectWagons.url,
      template: require('./templates/selectWagons.html'),
    })
    .state(scrapRoutes.createScrapping.path, {
      url: scrapRoutes.createScrapping.url,
      template: require('./templates/createScrapping.html'),
    })
    .state(scrapRoutes.report.path, {
      url: scrapRoutes.report.url,
      template: require('./templates/report.html'),
    })
}

export default scrapRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/scrap/scrap.routes.js